export enum AwkwardMomentType {
  LONG_PAUSE = 'LONG_PAUSE',
  INTERRUPTION = 'INTERRUPTION',
  SLOW_RESPONSE = 'SLOW_RESPONSE',
  INVALID_RESPONSE = 'INVALID_RESPONSE',
  AUDIO_OR_TRANSCRIPTION_ISSUE = 'AUDIO_OR_TRANSCRIPTION_ISSUE',
  OTHER = 'OTHER',
}

export const AWKWARD_MOMENT_TYPE_OPTIONS = [
  {
    value: AwkwardMomentType.LONG_PAUSE,
    label: 'Long pause',
  },
  {
    value: AwkwardMomentType.INTERRUPTION,
    label: 'Interruption',
  },
  {
    value: AwkwardMomentType.SLOW_RESPONSE,
    label: 'Slow response',
  },
  {
    value: AwkwardMomentType.INVALID_RESPONSE,
    label: 'Invalid response',
  },
  {
    value: AwkwardMomentType.AUDIO_OR_TRANSCRIPTION_ISSUE,
    label: 'Audio or transcription issue',
  },
  {
    value: AwkwardMomentType.OTHER,
    label: 'Other',
  },
] as const;

export function isAwkwardMomentType(
  value: unknown
): value is AwkwardMomentType {
  return Object.values(AwkwardMomentType).includes(value as AwkwardMomentType);
}

export function getAwkwardMomentTypeLabel(
  awkwardMomentType: AwkwardMomentType
): string {
  return (
    AWKWARD_MOMENT_TYPE_OPTIONS.find(
      (option) => option.value === awkwardMomentType
    )?.label ?? awkwardMomentType
  );
}
